import Breadcrumb from './breadcrumb';
import './breadcrumb.sass';

export default Breadcrumb;
